<template>
    <div :title="$t('static.relations.hopwork.customer.satisfaction')" class="profile-rating">
        <VJoyIcon name="star-fill" color="quaternary" size="xsmall" />
        <span class="profile-rating__rating">{{ roundedRating }}</span>
        <span v-if="appraisalsWithRatesCount" class="joy-ml-1">({{ appraisalsWithRatesCount }})</span>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {VJoyIcon} from '@maltjoy/core-vue';

    const props = defineProps<{
        rating: number;
        appraisalsWithRatesCount: number;
    }>();

    const roundedRating = computed(() => Math.ceil(props.rating * 10) / 10);
</script>

<style scoped lang="scss">
    .profile-rating {
        display: flex;
        align-items: center;
        white-space: nowrap;

        &__rating {
            font-weight: var(--joy-font-weight-bold);
        }
    }
</style>
